import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  DialogTitle,
  Box,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const PriceListLineItemsModal = ({ open, onClose, record }) => {
  const [expandedRows, setExpandedRows] = useState({});

  const renderText = (value, key) => {
    const text = String(value || "");
    if (text.length <= 42 || expandedRows[key]) return text;

    return (
      <>
        {text.slice(0, 42)}...{" "}
        <Button
          size="small"
          onClick={() => setExpandedRows((prev) => ({ ...prev, [key]: true }))}
          sx={{ minWidth: "auto", p: 0, fontSize: "14px", textTransform: "none" }}
        >
          Read more...
        </Button>
      </>
    );
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle
        sx={{ fontSize: "18px", fontWeight: 600, fontFamily: "GilroySemiBold", pb: 1 }}
      >
        Price List Items
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: 1.5,
            mb: 2,
            p: 1.5,
            borderRadius: 1.5,
            backgroundColor: "#f8fafc",
            fontSize: "14px",
          }}
        >
          <Box><strong>Company Name:</strong> {record?.vendor_details?.company_name || record?.company_details?.company_name || ""}</Box>
          <Box><strong>GST:</strong> {record?.vendor_details?.gst_number || record?.company_details?.gst_number || ""}</Box>
          <Box><strong>PAN:</strong> {record?.vendor_details?.pan_number || record?.company_details?.pan_number || ""}</Box>
          <Box><strong>Location:</strong> {record?.vendor_details?.location || record?.company_details?.location || ""}</Box>
        </Box>
        <Box sx={{ mt: 1, width: "100%", overflowX: "auto" }}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
            }}
          >
            <Table stickyHeader sx={{ "& .MuiTableCell-root": { whiteSpace: "nowrap", fontSize: "14px" } }}>
              <TableHead>
                <TableRow>
                  {["Sl No", "Part No", "Item Code", "Item Name", "Description", "Qty", "UOM", "Unit Price", "GST", "Total Price"].map(
                    (header, index) => (
                      <TableCell
                        key={index}
                        sx={{
                          fontWeight: 600,
                          fontFamily: "GilroySemiBold",
                          backgroundColor: "#e0e9ee",
                          fontSize: "14px",
                          borderBottom: "1px solid #e2e8f0",
                        }}
                      >
                        {header}
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableHead>

              <TableBody>
                {(record?.line_items || []).map((item, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: "white",
                      "&:hover": { backgroundColor: "#f5f5f5" },
                      borderBottom: "1px solid #e2e8f0",
                    }}
                  >
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.row_number || index + 1}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.part_no === "-" ? "" : item.part_no || ""}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.item_code || ""}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.item_name || ""}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px", whiteSpace: "normal !important", minWidth: 260, maxWidth: 360, width: 360, overflowWrap: "anywhere", wordBreak: "break-word" }}>
                      {renderText(item.description || item.extra_fields?.["Specification / Brand"], `${index}-description`)}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.quantity || item.extra_fields?.MOQ || ""}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.uom || ""}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.currency || "₹"} {item.unit_price || item.extra_fields?.["Unit Price (n)"] || ""}
                    </TableCell>
                    <TableCell sx={{ fontFamily: "GilroyMedium", fontSize: "14px" }}>
                      {item.extra_fields?.GST || item.tax_percent || ""}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "GilroyMedium",
                        fontSize: "14px",
                        color: "#075b97",
                        fontWeight: 600,
                      }}
                    >
                      {item.currency || "₹"} {item.total_price || item.total_line_value || item.extra_fields?.["Price Incl. GST (n)"] || ""}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={onClose} sx={{ textTransform: "none", fontSize: "14px" }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PriceListLineItemsModal;
